import {ProductDetailsMobile} from '@components/product/ProductDetailsMobile';
import {JsonLdBreadcrumbList} from '@components/json-ld/breadcrumb-list';
import {ProductDetailsDesktop} from '@components/product/ProductDetailsDesktop';
import {LoadingDots} from '@components/widgets/LoadingDots/LoadingDots';
import {useProductProvider} from '@components/product/ProductProvider';
import {
  generalSingleProductNonVariantJsonLD
} from '@helpers/products/json-ld/json-ld-generate-product.mjs';
import {
  generateItemWithVariantsJsonLd
} from '@helpers/products/json-ld/json-ld-generate-items-with-variants.mjs';

export const ProductDetails = ({reviewsFromDb}) => {
  // console.log('[ProductDetails] reviewsFromDb:', reviewsFromDb);
  const {sku, breadcrumbs} = useProductProvider();

  const handle = breadcrumbs?.breadCrumbLevel1;
  const title = breadcrumbs?.breadCrumbLevel1Title;
  const handle2 = breadcrumbs?.breadCrumbLevel2;
  const title2 = breadcrumbs?.breadCrumbLevel2Title;
  const handle3 = breadcrumbs?.breadCrumbLevel3;
  const title3 = breadcrumbs?.breadCrumbLevel3Title;

  if (!sku) {
    return (
      <div className="h-16 bg-gray-100 text-center pt-4">
        <LoadingDots />
      </div>
    );
  }

  return (
    <>
      {/* Using hidden divs vs const isMobile = useMobileOrTablet() is the only way to prevent CLS issues */}
      <div className={'hidden md:block'}>
        <div className="md:block my-0 pt-1">
          <ProductDetailsDesktop />
        </div>
      </div>
      <div className={'md:hidden'}>
        <div className="text-black font-oswald">
          <ProductDetailsMobile reviewsFromDb={reviewsFromDb} />
        </div>
      </div>

      <JsonLdBreadcrumbList
        handle={handle}
        title={title}
        handle2={handle2}
        title2={title2}
        handle3={handle3}
        title3={title3}
      />

      <JsonLdProductWithVariants reviewsFromDb={reviewsFromDb} />
    </>
  );
};

export const JsonLdProductWithVariants = ({reviewsFromDb}) => {
  // console.log('[JsonLdProductWithVariants] reviewsFromDb:', reviewsFromDb);
  const product = useProductProvider();
  // console.log("[JsonLdProductWithVariants] product:", product);

  const isTrueVariantSku = product?.product_type === 'variant';
  // console.log('[JsonLdProductWithVariants] isTrueVariantSku:', isTrueVariantSku);

  const selectedVariant = product?.selectedVariant;
  const seoTitle = product?.seoTitle;
  const seoDescription = product?.seoDescription;
  const variants = product?.variants;
  // console.log("[JsonLdProductWithVariants] variants:", selectedVariant);
  // console.log("[JsonLdProductWithVariants] variants:", variants);


  let jsonLd;
  if (isTrueVariantSku && variants?.length >= 1) {
    jsonLd = generateItemWithVariantsJsonLd(product, reviewsFromDb);
  } else {
    jsonLd = generalSingleProductNonVariantJsonLD(selectedVariant, reviewsFromDb, seoTitle, seoDescription);
  }

  // console.dir({jsonLd}, {depth: null});
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{__html: JSON.stringify(jsonLd)}}
      key="product-jsonld"
    />
  );
};
